import { useState } from 'react'
import { ZoomControls } from './ZoomControls'
import { ViewToggle } from './ViewToggle'
import { PDFViewer } from './PDFViewer'
import { CodeEditor } from './CodeEditor'
import styles from './PreviewPanel.module.css'

interface PreviewPanelProps {
  viewMode: 'pdf' | 'code'
  onViewModeChange: (mode: 'pdf' | 'code') => void
  latexSource: string
  onLatexChange: (source: string) => void
  pdfUrl: string | null
  isCompiling: boolean
  compilationError: string | null
  onPageCountChange?: (pageCount: number) => void
}

export function PreviewPanel({
  viewMode,
  onViewModeChange,
  latexSource,
  onLatexChange,
  pdfUrl,
  isCompiling,
  compilationError,
  onPageCountChange,
}: PreviewPanelProps) {
  const [zoom, setZoom] = useState(100)

  const handleZoomIn = () => setZoom((z) => Math.min(z + 10, 150))
  const handleZoomOut = () => setZoom((z) => Math.max(z - 10, 50))
  const handleToggle = () => onViewModeChange(viewMode === 'pdf' ? 'code' : 'pdf')

  return (
    <div className={styles.panel}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        {viewMode === 'pdf' ? (
          <PDFViewer
            pdfUrl={pdfUrl}
            zoom={zoom}
            isLoading={isCompiling}
            error={compilationError}
            onPageCountChange={onPageCountChange}
          />
        ) : (
          <CodeEditor
            value={latexSource}
            onChange={onLatexChange}
            isCompiling={isCompiling}
          />
        )}
      </div>
      <ViewToggle mode={viewMode} onToggle={handleToggle} />
      {viewMode === 'pdf' && (
        <ZoomControls level={zoom} onZoomIn={handleZoomIn} onZoomOut={handleZoomOut} />
      )}
      <div className={styles.vignette} />
    </div>
  )
}
